import 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import '../css/App.css';

$(document).ready(function() {

    var map = new L.Map("map", {
        center: new L.LatLng(47.0349968, 4.9241846),
        zoom: 6,
        zoomControl: false
        });

    L.control.zoom({
        position: 'topright'
    }).addTo(map);


//Definition des différents layers
const overlays = new L.FeatureGroup();

const osm = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    maxNativeZoom: 19,
    continuousWorld: true,
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
    id: 'osm'
}).addTo(map);
//Definition de la carte

map.createPane("pane250").style.zIndex = 250; // between tiles and overlays
map.createPane("pane260").style.zIndex = 260; // between tiles and overlays
map.createPane("pane450").style.zIndex = 450; // between overlays and shadows
map.createPane("pane620").style.zIndex = 620; // between markers and tooltips
map.createPane("pane800").style.zIndex = 800; // above popups

function info (feature, layer) {
    const properties = feature.properties;
    const popup = L.popup({
        closeButton: true
    }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
        "<h5> Informations sur la zone avec l'id " + properties.id_zc_1 + " de la couche " +layer.options.name+ ": </h5> " +
        "<tr><th>Nbre de points dans la zone &nbsp;</th><td>" + properties.NUMPOINT_1 + "</td></tr>" +
        "<tr><th>Surface de vente totale &nbsp;</th><td>" + properties.Surf_Vente + "</td></tr>" +
        "<tr><th>Surface de vente moyenne &nbsp;</th><td>" + properties.SurfVMoy + "</td></tr>" +
        "<tr><th>Surface de vente médiane &nbsp;</th><td>" + properties.SurfVMed + "</td></tr>" +
        "<tr><th>Surface de vente minimale &nbsp;</th><td>" + properties.SurfVMin + "</td></tr>" +
        "<tr><th>Surface de vente maximale &nbsp;</th><td>" + properties.SurfVMax + "</td></tr>" +
        "<tr><th>Surface de vente 1er quartile &nbsp;</th><td>" + properties.SurfVQ1 + "</td></tr>" +
        "<tr><th>Surface de vente 3e quartile &nbsp;</th><td>" + properties.SurfVQ3 + "</td></tr>" +
        "<table>");
    layer.bindPopup(popup);
    layer.openPopup();
}

//Zones de CV

    var Zones_CV = L.geoJson(CVTotLSA,{
        color: "black",
        fillColor: "red",
        fillOpacity: 0.7,
        weight: 0.2,
        zIndex: 0,
        pane: "pane250",
        name: 'Zones de centre ville',
        onEachFeature: info
    });
    Zones_CV.name = 'Zones_CV';
    overlays.addLayer(Zones_CV);
    Zones_CV.bringToBack();

//Zones de RP
	
    var Zones_RP = L.geoJson(RPTotLSA,{
        color: "black",
        fillColor: "blue",
        fillOpacity: 0.7,
        weight: 0.2,
        zIndex: 10,
        pane: "pane260",
        name: 'Zones de retail park',
        onEachFeature: info
    }); 
        Zones_RP.name = 'Zones_RP';
        overlays.addLayer(Zones_RP);
        Zones_RP.bringToFront();

//Zones de RP sup à 150m²

var Zones_RP150 = L.geoJson(RPTotLSA150m,{
    color: "black",
    fillColor: "green",
    fillOpacity: 0.7,
    weight: 0.2,
    zIndex: 10,
    pane: "pane260",
    name: 'Zones de retail park sup 150',
    onEachFeature: info
}); 
    Zones_RP150.name = 'Zones_RP150';
    overlays.addLayer(Zones_RP150);
    Zones_RP150.bringToFront();

    
    function onEachFeaturePoints(feature, layer){
        var popup = L.popup({
            closeButton: true
        }).setContent("<table class='table table-striped table-bordered table-condensed'>" +
            "<tr><th>Identifiant base LSA :</th><td>" + layer.feature.properties.Ident + "</td></tr>" +
            "<tr><th>Type :</th><td>" + layer.feature.properties.Type + "</td></tr>" +
            "<tr><th>Nom de l'enseigne :</th><td>" + layer.feature.properties.Enseigne + "</td></tr>" +
            "<tr><th>Adresse :</th><td>" + layer.feature.properties.ADRESSE1 + "</td></tr>" +
            "<tr><th>Code postal :</th><td>" + layer.feature.properties.Code_posta + "</td></tr>" +
            "<tr><th>Ville :</th><td>" + layer.feature.properties.Ville + "</td></tr>" +
            "<tr><th>Surface de vente :</th><td>" + layer.feature.properties.Surf_Vente + "</td></tr>" +
            "<table>");
        layer.bindPopup(popup);
    }

//Points total LSA

    var markerClusters = new L.MarkerClusterGroup({
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 14
        });
    
    var geojsonMarkerOptions = {
        radius: 3,
        fillColor: "orange",
        color: "black",
        weight: 0.5,
        opacity: 1,
        fillOpacity: 0.8
    };
    
    var LSA_Total = L.geoJSON(LSATotal, {
        zIndex: 20,
        pane: "pane620",
        onEachFeature: onEachFeaturePoints,
        pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, geojsonMarkerOptions);
        }
    });
    let clusterLSATotal = markerClusters.addLayer(LSA_Total);
    clusterLSATotal.name = 'clusterLSATotal';
    overlays.addLayer(clusterLSATotal);
    //clusterLSATotal.bringToFront();

//Points pertinence 1 CV

    var markerClustersPert1CV = new L.MarkerClusterGroup({
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 14
        });

    var geojsonMarkerOptionsPert1CV = {
        radius: 3,
        fillColor: "green",
        color: "black",
        weight: 0.5,
        opacity: 1,
        fillOpacity: 0.8
    };
    
    var LSA_Pert1CV = L.geoJSON(LSAPert1CV, {
        zIndex: 30,
        pane: "pane800",
        onEachFeature: onEachFeaturePoints,
        pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, geojsonMarkerOptionsPert1CV);
        }
    });
    
    let clusterLSAPert1CV = markerClustersPert1CV.addLayer(LSA_Pert1CV);
    clusterLSAPert1CV.name = 'clusterLSAPert1CV';
    overlays.addLayer(clusterLSAPert1CV);
    clusterLSAPert1CV.bringToFront();

//Points pertinence 1 RP

    var markerClustersPert1RP = new L.MarkerClusterGroup({
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        disableClusteringAtZoom: 14
        });

    var geojsonMarkerOptionsPert1RP = {
        radius: 3,
        fillColor: "pink",
        color: "black",
        weight: 0.5,
        opacity: 1,
        fillOpacity: 0.8
    };
    
    var LSA_Pert1RP = L.geoJSON(LSAPert1RP, {
        zIndex: 30,
        pane: "pane800",
        onEachFeature: onEachFeaturePoints,
        pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, geojsonMarkerOptionsPert1RP);
        }
    });
    
    let clusterLSAPert1RP = markerClustersPert1RP.addLayer(LSA_Pert1RP);
    clusterLSAPert1RP.name = 'clusterLSAPert1RP';
    overlays.addLayer(clusterLSAPert1RP);
    clusterLSAPert1RP.bringToFront();


    $("input[name='overlays']").on('click', function(e) {
            //const donneesparcellesProprios = {propriosCad : propriosCad};
            $.ajax({
                    url: '../Tribekai_V3/assets/php/json.php', 
                    type: 'GET', 
                    //data: donneesparcellesProprios, 
                    success: (data) => {
                        console.log(data);
                        //$('#codeparcelleProprios').html(data);
                        }
                });
        e.stopPropagation();
        const idCheckbox=$(this).attr('id');
        //On boucle dans les overlays pour sélectionner la couche à afficher en fonction de la checkbox cliquée
        overlays.eachLayer(layer => {
            if(layer.name==idCheckbox){
                if (map.hasLayer(layer)) {
                    map.removeLayer(layer);
                } else {
                    map.addLayer(layer);
                }
            }  
        });
    });


});